// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"c5d8c6758dd92a02","3072":"8c68d6113632810f","5378":"8c68d6113632810f","7729":"b548ecafda394ffa"}[chunkId] + ".css";
};